import Vue from 'vue'

Vue.filter('formatTimeAgo', function (date) {
  if (!date) return ''

  if (!date) return date

  const now = new Date()
  const updated = new Date(date)
  const seconds = Math.floor((now - updated) / 1000)

  if (seconds < 60) return `hace ${seconds} segundos`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `hace ${minutes} minuto${minutes > 1 ? 's' : ''}`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `hace ${hours} hora${hours > 1 ? 's' : ''}`
  const days = Math.floor(hours / 24)
  return `hace ${days} dia${days > 1 ? 's' : ''}`
})
